import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import SubHeader from "./SubHeader";
import FormInput from "../forms/FormInput";
import { setLoading } from "../../actions/authAction";
import history from "../../history";
import api from "../../api/api";
import uri from "../../variables/uri";
import GroupModal from "../modals/GroupModal";
import AlertModal from '../modals/AlertModal';
import correctImg from '../../images/correct.png';
import incorrectImg from '../../images/incorrect.png';
import Pagination from 'rc-pagination';

class Group extends React.Component {
  state = {
    name: this.props.user.userID,
    user: this.props.user,
    isOpenMessage: false,
    isOpenConfirm: false,
    type:1,
    message: "",
    text: "",
    groupName: "",
    groupList:[],
    currentPage: 1,
    postsPerPage: 10,
    detailList:[],
    isOpenGroup:false
  };

  componentDidMount = async () => {
    if (!this.props.auth.isAuthen || (!this.props.auth.isAdmin && !this.props.auth.isEditor && !this.props.auth.isApprover)) {
      history.push("/");
    } else {
     this.onSearch();
    }
  };
 
  onGroupNameChange = (name) => {
    this.setState({ groupName:name});
  };

  onSearch = async () => {
    this.props.setLoading(true);
    try{
      const groupResponse = await api.get(
        `${uri.GET_GROUP}?name=${this.state.groupName}`
      );
    if (groupResponse.status === 200) {
        this.setState({
          groupList: groupResponse.data,
          currentPage:1
        });
        this.props.setLoading(false);
      }
    }catch(ex){
      this.setState({
        groupList: [],
      });
      this.props.setLoading(false);
    }
  };

  onDetail = async (id) => {
    history.push('/Permission/GroupDetail/'+id);
    // this.props.setLoading(true);
    // try{
    //   var response = await api.get(
    //     `${uri.GET_CHECKOUT_DETAIL}?requestId=${id}`
    //   );
    // if(response.status === 200){
      
    //   this.setState({isOpenDetail:true,detailList:response.data.ResponseData,selectedRequestId:id});
    //   this.props.setLoading(false);
    // }
    // }catch(ex){
    //   this.setState({isOpenDetail:false,detailList:[],selectedRequestId:id});
    //   this.props.setLoading(false);
    // }
  }

  onClose = () =>{
    this.setState({ isOpenDetail: false, isOpenMessage: false, isOpenConfirm:false});
  }

  onGroupModalClose = () => {
    this.setState({ isOpenGroup: false });
  }

  onGroupModalOpen = () => {
    this.setState({ isOpenGroup: true });
  }
  onGroupModalSuccess = () => {
    this.setState({ isOpenGroup: false });
    this.setState({ isOpenMessage: true, isOpenConfirm:false,message:"The data was saved successfully.",type:1});
    this.onSearch();
  }
  onShowSizeChange = (current, pageSize) => {
    this.setState({ currentPage:current });
  }
  render() {
    const indexOfLastPost = this.state.currentPage * this.state.postsPerPage;
    const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
    const currentPosts = this.state.groupList.slice(indexOfFirstPost, indexOfLastPost);
    return (
      <div className="home flex-v">
        <SubHeader text={`Manage Permission`} />
          <div className="flex-v flex-1">
            <div className="flex-v flex-1 pl-24 pr-24">
              <div
                className="flex-v bg-grey-lighter pl-16 pr-16 pb-16 mt-16"
                style={{ borderRadius: "10px" }}
              >
                <FormInput
                  value={this.state.groupName}
                  onValueChange={this.onGroupNameChange}
                  type="text"
                  placeholder="Group name"
                />
                  <div className=" flex-h mt-16 center buttons" >
                      <button onClick={() => this.onSearch()} className="button is-success center" >
                        Search
                      </button>    
                      <button onClick={() => this.onGroupModalOpen()} className="button is-info center" >
                          Add
                      </button>    
                  </div>
              </div>
            </div>
          </div>
        <div className="flex-v text-center p-16 mt-8">
            {this.state.groupList.length === 0 ?<div>Data not found.</div>:
              <div className="table-container">
                <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th>
                                #
                            </th>
                            <th>
                                Name
                            </th>
                            <th>
                                Active
                            </th>
                            <th>
                                Action
                            </th>
                        </tr>
                        </thead>
                        <tfoot>
                        <tr>
                            <td colSpan="7" style={{textAlign:'center'}}>
                            <Pagination className="ant-pagination" 
                              onChange={this.onShowSizeChange}
                              defaultCurrent={1} 
                              pageSize={this.state.postsPerPage} 
                              total={this.state.groupList.length} />
                            </td>
                        </tr>
                        </tfoot>
                        <tbody>
                            {currentPosts.map((item, i) =>{
                                return (
                                    <tr key={item.ID}>
                                        <td>
                                            {i+1}
                                        </td>
                                        <td>{item.Name}</td>
                                        <td>{item.Active?<img className="button-edit" src={correctImg} alt="Active" title="Active" />:<img className="button-edit" src={incorrectImg} alt="Inactive" title="Inactive" />}</td>
                                        <td>
                                          <button onClick={() => this.onDetail(item.ID)} className="button is-small is-info is-outlined">Edit</button>
                                        </td>
                                    </tr>
                                );
                            })}
                        
                    </tbody>
                </table>
              </div>
            }
          
        </div>
        <GroupModal isOpen={this.state.isOpenGroup} onClose={this.onGroupModalClose} onSuccess={this.onGroupModalSuccess}  />
        <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onClose} type={this.state.type} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.doa.user,
  };
};

export default connect(mapStateToProps, {
  setLoading,
})(Group);
